// This componenet is the parent component for login, signup Tab.

//imports
import React, { useState, useEffect, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import CareersRegisterSignUp from "../registration/CareersRegisterSignUp";
import CareersRegisterLogin from "../registration/CareersRegisterLogin";
import { AiOutlineClose } from "react-icons/ai";
import CommonModal from "../../components/utils/commonModal";
import logo from "../../assets/images/register/logo.svg";
import { useNavigate } from "react-router-dom";
import {
  getUserIp,
  getGeolocationData,
  getEmailDomainData,
  clearUserAuthenticationEmailResponse,
  clearUserAuthenticationResponse,
  clearLoginDataResponse,
  clearUserLoginSignupOtpResponse,
} from "../../../store/slices/Registration/CommonSlices";
import {
  clearTertiaryCheckboxResponse
} from "../../../store/slices/Registration/SignUpSlices";
import {
  getGoogleSignInCheck
} from "../../../store/slices/Registration/GoogleSignInSlice";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import { createCurrentUrl, getAbsoluteDestinationUrl, certificationPage, deviceType, isSignupPage, isLoginPage } from "../../utils/registrationUtils";
import ReactGA from "react-ga";
import OtpVerify from "./RegistrationOtpVerify/OtpVerify";
import axios from "axios";
import {gaEvent, gaLocationAndContentData} from "../../utils/index";
import GoogleSignIn from "./GoogleSignIn";

const CareersRegisterRight = (props) => {
  //  -----------Local States----------- 
  const [open, setOpen] = useState(false);
  const [tabactive, setTabActive] = useState(0);
  const [clearValues, setClearValues] = useState(false);
  const [removeTab, setRemoveTab] = useState(false);
  const [reloadFlagOnExit, setReloadFlagOnExit] = useState(true);
  const [remainingSeconds, setRemainingSeconds] = useState(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0));
  const [currentFieldsCount, setCurrentFieldsCount] = useState(0);

  // ------------Local Variables------------
  const cookies = new Cookies();
  let date = new Date();
  const navigate = useNavigate();
  //to check correct current url
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
   window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/otp-verify"];
  const currentDeferrerUrl = document.referrer
  const currentCookieUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const isMatch = urls.some(path => currentDeferrerUrl?.includes(path));
  const currentUrl = isMatch ? currentCookieUrl : currentDeferrerUrl;
  const urlObj = currentUrl ? new URL(currentUrl) : null;
  const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
  const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
//---------------------------------------
  const url = useRef("");
  let isSignupOtpVerifyScreen = (window?.location?.pathname?.includes('user/otp-verify'));
  let isLoginOtpVerifyPage = window.location.pathname?.includes("/user/login/otp-verify");

  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME;
    const tabs = [
      {
        id: "signup",
        tabName: "Sign Up",
        url: "/user/register",
        component: <CareersRegisterSignUp domain={props.domain}
          clearValues={clearValues}
          setClearValues={setClearValues}
          setRemoveTab={setRemoveTab}
          reloadFlagOnExit={reloadFlagOnExit}
          setCurrentFieldsCount={setCurrentFieldsCount}
        />,
      },
      {
        id: "login",
        tabName: "Login",
        url: "/user/login",
        component: <CareersRegisterLogin domain={props.domain}
          clearValues={clearValues}
          setClearValues={setClearValues}
          setTabActive={setTabActive}
          setRemainingSeconds={setRemainingSeconds}
          remainingSeconds={remainingSeconds}
        />,
      }
    ];
    const isWebView = () => {
      const userAgent = navigator?.userAgent || window?.opera;
      // Check for Android WebView
      if (/wv|Android.*Version\/[0-9.]+.*Chrome\/[0-9.]+ Mobile Safari\/[0-9.]+/.test(userAgent)) {
        return true;
      }
  
      // Check for iOS WebView
      if (/iP(hone|ad|od).*AppleWebKit(?!.*Safari)/.test(userAgent)) {
        return true;
      }
  
      return false;
    };
// checks added for google sigin visibility on login and signup
  const isGoogleSigninEnabled = !isWebView() && (isSignupPage ? !!props.googleSigninCheck?.google_signup : isLoginPage ? !!props.googleSigninCheck?.google_login : false);

  // ----------------UseEffects------------
  useEffect(() => {
    if (window.location.pathname?.includes("/user/login")) {
      setTabActive(1)
    } else {
      setTabActive(0)
    }
    const tabIndex = tabs.findIndex((tab) => tab.url === url.current);
    if (tabIndex !== -1) {
      setTabActive(tabIndex);
    }
    // Dispatch user IP API.
    props.dispatch(getUserIp());

    let formState = cookies.get("registrationState");
    if (formState) {
      if ((formState?.currentScreen?.page === 'signup' && !(formState?.currentScreen?.screen > 1))) {
        setTabActive(0);
      }
    }
    
    // Dispatch an action to get email domain data
    let params = {};
    params.current_url = sourseDestination || createCurrentUrl();
    params.field = "email_domain";
    props.dispatch(getEmailDomainData(params));

  }, []);

  useEffect(() => {
    // If reloadFlagOnExit is false, this is done to stop browser popup while redirection to another url.
    if (!reloadFlagOnExit) {
      setReloadFlagOnExit(true);
        // Redirect to the current URL or create a new current URL
        window.location.href = cleanUrl || getAbsoluteDestinationUrl();
    }
}, [reloadFlagOnExit]);

useEffect(() => {
    // If user IPs or user IP error is available in props
    if (props.userIps || props.userIpError) {
        // Dispatch an action to get geolocation data using the user's IPv4 address
        props.dispatch(getGeolocationData({ ip: props.userIps?.ip }));
    }
}, [props.userIps || props.userIpError]);

useEffect(() => {
    // Find the index of the 'signup' tab in the tabs array
    let signupObject = tabs.findIndex(obj => obj.id === 'signup');

    // Find the index of the 'login' tab in the tabs array
    let loginObject = tabs.findIndex(obj => obj.id === 'login');

    // Check if the current window URL matches '/user/login'
    if (checkWindowUrl('/user/login')) {
        // Set the active tab to the login tab
        setTabActive(loginObject);
        // Ensure the tab is not removed
        setRemoveTab(false);
    } else if (checkWindowUrl('/user/register')) { // Check if the current window URL matches '/user/register'
      // Set the active tab to the signup tab
        setTabActive(signupObject);
        // Ensure the tab is not removed
        setRemoveTab(false);

        // Set a cookie 'rgData' with updated common_sign_up_mobile value and expiration date
        cookies.set("rgData", { ...(cookies?.get("rgData") || {}), common_sign_up_mobile: null }, {
            path: "/",
            expires: new Date(date.setDate(date.getDate() + 365)), // Set expiration date to one year from now
            domain: destinationDomain,
            sameSite: "Lax",
        });
    }
});

  // -----------Local Functions--------------
const GAEventsDataOnMultipleScreens = () => {
  if(window.location.pathname?.includes("/user/register")){
    gaEvent("skipsignup", "login_signup", `${gaLocationAndContentData}`, `${currentFieldsCount}`);
  }else if(window.location.pathname?.includes("/user/login") && !window.location.pathname?.includes("/user/login/otp-verify")){
    gaEvent("skipsignin", "login_signup", `${gaLocationAndContentData}`, "1");
  }else if(window.location.pathname?.includes("/user/otp-verify") && cookies.get("registrationState")?.currentScreen?.screen == 2){
    gaEvent("skipmobileotpverify", "login_signup", `${gaLocationAndContentData}`, "");
  }else if(window.location.pathname?.includes("/user/otp-verify") && cookies.get("registrationState")?.currentScreen?.screen == 3){
    gaEvent("skipemailotpverify", "login_signup", `${gaLocationAndContentData}`, "");
  }else if(window.location.pathname?.includes("/user/login/otp-verify") && cookies.get("loginState")?.email_field_visibility == false){
    gaEvent("skipmobileotpverify", "login_signup", `${gaLocationAndContentData}`, "");
  }else if(window.location.pathname?.includes("/user/login/otp-verify") && cookies.get("loginState")?.email_field_visibility){
    gaEvent("skipemailotpverify", "login_signup", `${gaLocationAndContentData}`, "");
  }
}

  // Function to handle navigation based on an object value
const handleNavigate = (obj) => {
  // If the passed object is "yes"
  if (obj === "yes") {
    setOpen(false);
    GAEventsDataOnMultipleScreens();
      // Remove the "registrationState" cookie
      cookies.remove("registrationState", {
          path: "/",
          domain: destinationDomain,
      });
      // Remove the "loginState" cookie
      cookies.remove("loginState", {
          path: "/",
          domain: destinationDomain,
      });
      // Remove the "user-agent-key" cookie with the current domain
      cookies.remove("user-agent-key", {
          path: "/",
          domain: destinationDomain,
      });

      // Set the reload flag to false
      setReloadFlagOnExit(false);

      // Set the "rgData" cookie with updated common_sign_up_mobile value and expiration date
      cookies.set("rgData", { ...(cookies?.get("rgData") || {}), common_sign_up_mobile: null }, {
          path: "/",
          expires: new Date(date.setDate(date.getDate() + 365)), // Set expiration date to one year from now
          domain: destinationDomain,
          sameSite: "Lax",
      });
  }
}

// Function to check if the current window URL includes the given parameters
const checkWindowUrl = (params) => {
  return window.location.pathname.includes(params);
}

// Function to clear various Redux states related to user authentication and login
const handleReduxStates = () => {
  // Dispatch action to clear user authentication email response
  props.dispatch(clearUserAuthenticationEmailResponse());

  // Dispatch action to clear user authentication response
  props.dispatch(clearUserAuthenticationResponse());

  // Dispatch action to clear login data response
  props.dispatch(clearLoginDataResponse());

  // Dispatch action to clear user login/signup OTP response
  props.dispatch(clearUserLoginSignupOtpResponse());

  // Dispatch action to clear tertiary checkbox response
  props.dispatch(clearTertiaryCheckboxResponse());
}

 // Function For GA Events.
 const GAEventsData = (tabName) => {
  if(tabName == "Login"){
    gaEvent("onloadsignin", "login_signup", `${gaLocationAndContentData}`, "");
  }else{
    gaEvent("onloadsignup", "login_signup", `${gaLocationAndContentData}`, "");
  }
  handleReduxStates();
 }

  return (
      <div>
        <div className="careers_register_tab">
      {/* Render the tab list if removeTab is false, not on the signup OTP verify screen, login not proceeded, and ask_update_profile is not false */}
          {!removeTab && !isSignupOtpVerifyScreen && !props.loginDatas?.proceed && props.loginDatas?.ask_update_profile !== false && (
            <div className="careers_registe_tabs_outer">
              <ul className="careers_register_tab_list">
                {/* Map through the tabs and render each tab as a list item */}
                {tabs?.map((obj, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      GAEventsData(obj.tabName === "Login" ? "Login" : "Signup"); // Clear various Redux states
                      setTabActive(index); // Set the active tab to the clicked tab
                      navigate(`${obj.url}${window.location.search}`); // Navigate to the URL of the clicked tab with query parameters
                    }}
                    className={tabactive === index ? "tab_active" : ""} // Apply the active class if the tab is active
                    id={obj.tabName === "Login" ? "/user/login" : "/user/register"} // Set the id based on the tab name
                  >
                    {obj.tabName}
                    <span></span>
                  </li>
                ))}
              </ul>
              {/* Google Signin Component - check whether Google CTA should be visible or not & pages condition*/}
              {isGoogleSigninEnabled &&
                <Col md={"6"} sm={"12"}>
                    <GoogleSignIn/>
                </Col>
               }
            </div>
          )}
                
          {/* Render the component of the active tab if not on the login OTP verify page */}
          {!isLoginOtpVerifyPage && <div>{tabs[tabactive]?.component}</div>}

          {/* Render the OTP verification component if on the login OTP verify page */}
          {isLoginOtpVerifyPage ? (
              <OtpVerify
                domain={props.domain}
                reloadFlagOnExit={reloadFlagOnExit}
                setRemainingSeconds={setRemainingSeconds}
                remainingSeconds={remainingSeconds}
                setCurrentFieldsCount={setCurrentFieldsCount}
              />
          ) : null}
        </div>

        {/* Render the close icon if the device type is desktop */}
        {deviceType === "web" && (
          <AiOutlineClose
            className="close_icon"
            onClick={() => {
              setOpen(true); // Open the modal
            }}
          />
        )}

        {/* CommonModal component for displaying a confirmation modal  */}
        <CommonModal
          isOpen={open}
          showCloseIcon={false}
          closeOnOverlayClick={false}
          closeOnEsc={false}
          closeModal={() => {
            setOpen(false); // Close the modal
          }}
          classNames={{ root: "continue_modal" }}
        >
          <div className="careers_register_modal">
            <div className="careers_register_modal_header">
              <img src={logo} alt="logo" />
            </div>
            <div className="careers_register_modal_body careers_register_modal_body_back_button">
              <p>Wait! Your learning journey is just one step away.</p>
              <p>By exiting, you may not be able to access resources.</p>
              <p>Do you want to continue?</p>
              <div className="careers_register_modal_buttons">
                {/* Button to exit and handle the navigate logic */}
                <button onClick={() => handleNavigate("yes")}>
                  {deviceType === "mobile" ? "No, exit" : "No, I want to Exit"}
                </button>
                {/* Button to close the modal and continue */}
                <button
                  className="careers_register_modal_button_active"
                  onClick={() => setOpen(false)}
                >
                  {deviceType === "mobile" ? "Yes, Continue" : "Yes, I want to Continue"}
                </button>
              </div>
            </div>
          </div>
        </CommonModal>

      </div >
    );
  };
const mapStateToProps = (state) => {
  return {
    userIps: state.usersCommonData?.userIp,
    userIpError: state.usersCommonData?.userIpError,
    loginDatas: state.usersCommonData?.loginData,
    geoLocationLoading: state.usersCommonData?.geoLocationLoading,
    googleSigninCheck: state.usersGoogleSiginIn?.googleSigninCheckData
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CareersRegisterRight);


